(function () {
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    var t = document.querySelector('.nav-toggle');
    var n = document.getElementById('nav');
    if (t && n) {
      t.addEventListener('click', function () {
        var open = n.classList.toggle('open');
        t.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
  });
})();
(function () {
  function go() { var h = document.getElementById('hero'); if (h) h.classList.add('hero--ready'); }
  if (document.readyState === 'complete') go(); else window.addEventListener('load', go);
})();
